import { createFileRoute, redirect } from '@tanstack/react-router';

// NOT-21: Crew Members are the same individuals as Technicians, so the nav item
// is folded into Technicians. This route stays as a redirect to preserve old
// bookmarks / deep links.
export const Route = createFileRoute('/_dashboard/dashboard/crew-members')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/technicians' });
  },
  component: () => null,
});
